import { SCard, SIcon, SHeader, SBody, SFooter } from '../styles';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Card = ({ Icon, title, description, footer, ...props }) => {
  let titleComponent;
  let descriptionComponent;
  let footerComponent;

  // console.log(
  //   `title height: ${props.titleHeight} description height: ${props.descriptionHeight} footer height: ${props.footerHeight}`,
  // );

  useEffect(() => {
    let calculatedTitleHeight;
    let calculatedDescriptionHeight;
    let calculatedFooterHeight;

    try {
      // get current height of title
      calculatedTitleHeight = titleComponent.clientHeight;

      // get current height of description
      calculatedDescriptionHeight = descriptionComponent.clientHeight;

      // get current height of footer
      calculatedFooterHeight = footerComponent.clientHeight;

      // Store it in parent component
      props.callbackTitle(calculatedTitleHeight);
      props.callbackDescription(calculatedDescriptionHeight);
      props.callbackFooter(calculatedFooterHeight);
    } catch (e) {
      console.log(e);
    }
  });

  return (
    <SCard {...props}>
      <SHeader>
        <SIcon>
          <Icon />
        </SIcon>
      </SHeader>
      <SBody>
        {title && (
          <p className="title" ref={component => (titleComponent = component)}>
            {title}
          </p>
        )}
        {description && (
          <p
            className="description"
            ref={component => (descriptionComponent = component)}
          >
            {description}
          </p>
        )}
      </SBody>
      {footer && (
        <SFooter>
          <p
            className="footer"
            ref={component => (footerComponent = component)}
          >
            {footer}
          </p>
        </SFooter>
      )}
    </SCard>
  );
};

Card.propTypes = {
  Icon: PropTypes.any,
  title: PropTypes.string,
  description: PropTypes.string,
  cardId: PropTypes.string,
  $moveUp: PropTypes.bool,
  inLine: PropTypes.bool,
  callbackDescription: PropTypes.func,
  callbackFooter: PropTypes.func,
  callbackTitle: PropTypes.func,
  descriptionHeight: PropTypes.any,
  titleHeight: PropTypes.any,
  footerHeight: PropTypes.any,
  footer: PropTypes.any,
};

export default Card;
